<svelte:options accessors={true} />

<script>

    import Row from './Row.svelte'
    import InfoInput from './InfoInput.svelte'
    import YooMoney from './YooMoney.svelte'
    
    let order
    let updateTimer
    let doRerender = 0
    let detailsVisible = false
    let tariffId
    const forceUpdate = async (_) => { };
    export let busy = false

    async function trialStart() {
        busy = true
        let resp = await app.request({'method': 'trialStart'})
        if (resp['status']) {
            app.account.trialAllow = false
            alert('Пробный период активирован до '+resp['trialUntil'])
        }
        busy = false
    }

    async function process() {
        busy = true
        alert('Платеж проводится через платежный провайдер YooMoney')
        await update()
        busy = false
    }

    export async function update() {
        clearTimeout(updateTimer)

        let req = {method: 'charge', tariff: tariffId}
        if (order) req.order = order.id;

        let resp = await app.request(req);
        if (resp.status == 1 && typeof resp.order !== 'undefined') {
            if (typeof order == 'undefined') order = resp.order;
            order.status = resp.order.status
            doRerender++;
        }

        updateTimer = setTimeout(() => { update() }, (order?3000:10000))
    }

    function fromBytes(bytes) {
        if (bytes > 1024*1024*1024) {
            return Math.round(bytes/1024/1024/1024,3) + ' Гб'
        } else if (bytes > 1024*1024) {
            return Math.round(bytes/1024/1024) + ' Мб'
        } else if (bytes > 1024) {
            return Math.round(bytes / 1024) + ' Кб'
        } else {
            return bytes + ' Б';
        }
    }

</script>

<Row title="{app.account.name}" info="" busy={busy}>
    <div class="container h-100">

            <!-- <InfoInput title="Трафик сегодня" value={fromBytes(app.account.traffic.day)} copyAllow={false}/> -->
            {#await forceUpdate(doRerender) then _}
                <InfoInput title={(app.account.trialAllow?'Пробный период':'Осталось дней')} value="" customSlot={true}>
                    {#if app.account.days < 1}
                            {#if app.account.trialAllow}
                                <button on:click={trialStart} class="btn btn-success mr-2">активировать</button>
                            {:else}
                                <b style="color:chocolate">необходимо оплатить</b>
                            {/if}
                    {:else}
                            <input class="form-control" value="{app.account.days}" readonly="readonly"/>
                    {/if}
                </InfoInput>
                <InfoInput title="Оплатить 🇷🇺 ₽" customSlot={true}>
                    {#if order}
                        {#if order.status == 1}
                            <b style="color:darkgreen">платеж поступил</b>
                        {:else}
                            <YooMoney value="{order.amount}" account="41001637108267" name="Счёт {order.id}" ></YooMoney>
                        {/if}
                    {:else}
                        <button on:click={() => { tariffId = 30; process(); }} class="btn btn-secondary mr-2">+30 дней</button>
                        <button on:click={() => { tariffId = 90; process(); }} class="btn btn-secondary mr-2">+90 дней (-10%)</button>
                    {/if}
                </InfoInput>
            {/await}
            {#if app.account.refByName}
                <InfoInput title="От пользователя" value={app.account.refByName} copyAllow={false}/>
            {/if}
            <hr align=center size=3 color="grey" class="mt-1" />
            <InfoInput title="Инструкции" customSlot={true}>
                <button target="_blank" role="button" on:click={() => { app.pageChange('instrution:ios'); return false;}} class="btn btn-secondary mr-2">iPhone/iPad</button>
                <button target="_blank" role="button" on:click={() => { app.pageChange('instrution:android'); return false;}} class="btn btn-secondary mr-2">Android</button>
            </InfoInput>
            <hr align=center size=3 color="grey" class="mt-2" />
            <div style="text-align:center;" class="mb-3">
                <button href="#" on:click={()=>{detailsVisible = !detailsVisible; return true;}} class="btn btn-secondary mr-2">
                    {#if !detailsVisible}
                        Данные для подключения VPN
                    {:else}
                        Скрыть
                    {/if}
                </button>
            </div>
            {#if detailsVisible}
                <InfoInput title="Тип VPN" value="L2TP" copyAllow={false} />
                <InfoInput title="Сервер" value="v.mshv.me" />
                <InfoInput title="Логин" value={app.account.login} />
                <InfoInput title="Пароль" value={app.account.password} />  
                <InfoInput title="Общий ключ" value="ALASKA" />
            {/if}
            <hr align=center size=3 color="grey" class="mt-2" />
            <InfoInput title="Реферальная программа" value={`https://v.mshv.me/?ref=${app.account.id}`} copyAllow={true}/>
            <p>За каждого нового и оплатившего впн пользователя по твоей персональной ссылке☝️ ты получишь +30 дней на счёт в качестве благодарности 🙏☺️.</p>
    </div>

    <div style="text-align:center;font-size:13px;color:gray;" class="mt-4">
        Telegram: <a style='color:gray;' href='https://t.me/vpnmshv/2'>канал</a> | <a style='color:gray;' href='https://t.me/+UiJw_fh-_FwxMGQ6'>чат</a><br/><a href="#" on:click="{() => app.logout()}">выход</a>
    </div>

</Row>

